Vue.component('admin-exotic-cards', {
  template: templates.adminExoticCards,
  data() {
    return {
      model: {
        edit: false,
        mode: 'new', // 'new' | 'modify'
        baseCardId: null,
        card: {
          name: null,
          hp: 0,
          attack: 0,
          defence: 0,
          accuracy: 0,
          speed: 0,
          pAtk: 0,
          mAtk: 0,
          armor: 0,
          ward: 0,
          critChance: 5,
          critDamage: 150,
          stamina: 0,
          mana: 0,
          type: null,
          ability: null,
          trait: null,
          exotic: 1,
          active: false,
          image: null,
        },
        reward: {
          target: null,   // null | 'event' | 'quest'
          targetId: null,
        },
        cards: {},
        allCards: {},
        types: {},
        abilities: {},
        traits: [],
        events: [],
        quests: [],
        tiers: {
          '1': { name: 'Standard' },
          '2': { name: 'Ultra' },
          '3': { name: 'Legendary' },
          '4': { name: 'Ultimate' },
        },
      }
    }
  },
  watch: {
    'model.card.image': function() {
      this.$forceUpdate();
    }
  },
  computed: {
    activeEvents() {
      const today = new Date().toISOString().slice(0, 10);
      return this.model.events.filter(e => e.to >= today);
    }
  },
  mounted() {
    const c = this;
    c.get();
    c.getAllCards();
    c.getTypes();
    c.getAbilities();
    c.getTraits();
    c.getEvents();
    c.getQuests();

    c.$root.$on('remove-existing-image', data => {

      c.removeCurrentFile(data);
    })
  },
  methods: {
    get() {
      const c = this;
      let data = {};
      exoticCardService.get()
        .then(function (response) {
          for (let d of response.data) {
            d.image = [`${d.id}.png`];
            data[`${d.id}`] = d;
          }
          c.model.cards = data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getAllCards() {
      const c = this;
      let data = {};
      cardService.get()
        .then(function (response) {
          for (let d of response.data) {
            data[`${d.id}`] = d;
          }
          c.model.allCards = data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getTypes() {
      const c = this;
      let data = {};
      typeService.get()
        .then(function (response) {
          for (let d of response.data) {
            data[`${d.id}`] = d;
          }
          c.model.types = data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getAbilities() {
      const c = this;
      let data = {};
      abilityService.get()
        .then(function (response) {
          for (let d of response.data) {
            data[`${d.id}`] = d;
          }
          c.model.abilities = data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getTraits() {
      const c = this;
      traitService.get()
        .then(function (response) {
          c.model.traits = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getEvents() {
      const c = this;
      eventsService.get()
        .then(function (response) {
          c.model.events = Array.isArray(response.data) ? response.data : Object.values(response.data);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getQuests() {
      const c = this;
      questLineService.get()
        .then(function (response) {
          c.model.quests = Array.isArray(response.data) ? response.data : Object.values(response.data);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    switchMode(mode) {
      const c = this;
      c.model.mode = mode;
      c.model.baseCardId = null;
      c.resetCardStats();
    },
    selectBaseCard(cardId) {
      const c = this;
      c.model.baseCardId = cardId;
      if (!cardId) {
        c.resetCardStats();
        return;
      }
      const base = c.model.allCards[cardId];
      if (!base) return;
      c.model.card = {
        ...c.model.card,
        name: base.name + ' (Exotic)',
        hp: base.hp,
        attack: base.attack,
        defence: base.defence,
        accuracy: base.accuracy,
        speed: base.speed,
        pAtk: base.pAtk,
        mAtk: base.mAtk,
        armor: base.armor,
        ward: base.ward,
        critChance: base.critChance,
        critDamage: base.critDamage,
        stamina: base.stamina,
        mana: base.mana,
        type: base.typeId || base.type,
        ability: base.ability,
        trait: base.trait,
        exotic: 1,
        image: null,
      };
    },
    resetCardStats() {
      const c = this;
      c.model.card = {
        name: null,
        hp: 0,
        attack: 0,
        defence: 0,
        accuracy: 0,
        speed: 0,
        pAtk: 0,
        mAtk: 0,
        armor: 0,
        ward: 0,
        critChance: 5,
        critDamage: 150,
        stamina: 0,
        mana: 0,
        type: null,
        ability: null,
        trait: null,
        exotic: 1,
        active: false,
        image: null,
      };
    },
    add() {
      const c = this;
      c.model.edit = true;
      c.model.mode = 'new';
    },
    edit(id) {
      const c = this;
      const data = c.model.cards[`${id}`];
      if (id == c.model.card.id) {
        c.model.edit = false;
        return;
      }
      c.model.edit = true;
      c.model.mode = 'new';
      c.model.baseCardId = null;
      c.model.card = {
        id: id,
        name: data.name,
        hp: data.hp,
        attack: data.attack,
        defence: data.defence,
        accuracy: data.accuracy,
        speed: data.speed,
        pAtk: data.pAtk,
        mAtk: data.mAtk,
        armor: data.armor,
        ward: data.ward,
        critChance: data.critChance,
        critDamage: data.critDamage,
        stamina: data.stamina,
        mana: data.mana,
        type: data.type || data.typeId,
        ability: data.ability,
        trait: data.trait,
        exotic: 1,
        active: data.active,
        image: data.image,
      };
    },
    save() {
      const c = this;
      const data = c.model.card;

      if (!data.name) {
        utils.alert.error('Name is required');
        return;
      }

      if (data.hp <= 0 || data.pAtk <= 0 || data.mAtk <= 0 || data.speed <= 0 || data.accuracy <= 0) {
        utils.alert.error('HP, Physical Attack, Magic Attack, Speed, and Accuracy are required');
        return;
      }

      if (c.model.reward.target && !c.model.reward.targetId) {
        utils.alert.error('Please select an event or quest to link this card to');
        return;
      }

      exoticCardService.save(data)
        .then(function (response) {
          const savedId = data.id || response.data.id;
          if (!data.id) {
            data.id = savedId;
            data.image = [`${savedId}.png`];
          }
          c.model.cards[`${savedId}`] = { ...data };

          if (c.model.reward.target && c.model.reward.targetId) {
            return exoticCardService.link({
              targetType: c.model.reward.target,
              targetId: c.model.reward.targetId,
              cardId: savedId,
            });
          }
        })
        .then(function () {
          c.reset();
          utils.alert.success('Saved!');
        })
        .catch(function () {
          utils.alert.error('Failed to save.');
        });
    },
    toggle(id) {
      const c = this;
      const card = c.model.cards[`${id}`];
      card.active = !card.active;
      exoticCardService.toggleActive({ id: id, active: card.active ? 1 : 0 })
        .then(function () {
          utils.alert.success('Updated!');
        })
        .catch(function () {
          utils.alert.error('Failed to update.');
        });
    },
    delete(id) {
      if (!confirm('Are you sure you want to delete this exotic card?')) {
        return;
      }
      const c = this;
      const card = { ...c.model.cards[`${id}`], deleted: true };
      exoticCardService.save(card)
        .then(function () {
          delete c.model.cards[`${id}`];
          utils.alert.success('Deleted!');
        })
        .catch(function () {
          utils.alert.error('Failed to delete.');
        });
    },
    reset() {
      const c = this;
      c.model.edit = false;
      c.model.mode = 'new';
      c.model.baseCardId = null;
      c.model.reward = { target: null, targetId: null };
      c.resetCardStats();
    },
    getCardUrl(){
      const c = this;
      const url = `${root}/images/cards/`;
      return url;
    },
    handleCardImageUpload(data){
      const c = this;
      const newImage = [`${data.id}.png?t=${Date.now()}`]; // cache-bust timestamp

      c.model.card.image = newImage;

      c.$set(c.model.cards[`${data.id}`], 'image', newImage);

      c.refreshImage();
    },
    refreshImage() {
      const c = this;
      const imageUrl = `${c.getCardUrl()}${c.model.card.image}`;
      
      c.checkImageExists(imageUrl).then(exists => {
        if (!exists) {
          c.model.card.image = null; 
          c.model.cards[`${c.model.card.id}`].image = null
        }
      });
    },
    checkImageExists(url) {
      return new Promise((resolve) => {
        const img = new Image();
        img.src = url;
        img.onload = () => resolve(true);
        img.onerror = () => resolve(false);
      });
    },
  },
  removeCurrentFile(data){
    const c = this;
    const id = c.model.card.id;

    uploadService.deleteFile('cards', id, data.image)
      .then(function (response) {
        c.model.card.image = null;
        c.$set(c.model.cards[`${id}`], 'image', null); // ← add this
        utils.alert.success('File Removed!');
      })
      .catch(function (error) {
        utils.alert.error(error);
      });
  },
});
